import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
    //namespaced: true,
    state: {
        _socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
        },
    },
    mutations: {
        SOCKET_ONOPEN (state, event)  {
            Vue.prototype.$socket = event.currentTarget;
            state._socket.isConnected = true;
        },
        SOCKET_ONCLOSE (state)  {
            state._socket.isConnected = false;
        },
        SOCKET_ONERROR (state, event)  {
            console.error(state, event);
        },
        SOCKET_ONMESSAGE (state, message)  {
            state._socket.message = message;
        },
        SOCKET_RECONNECT(state, count) {
            console.info(state, count)
        },
        SOCKET_RECONNECT_ERROR(state) {
            state._socket.reconnectError = true;
        },
    }
}